import { computed } from 'vue';
import { assoc, dissoc } from 'ramda';

export const show = queue => key => {
  queue.value = assoc(`item-${key}`, !queue.value[`item-${key}`] ? 0 : queue.value[`item-${key}`] + 1, queue.value);
};

export const hide = queue => key => {
  if (!queue.value[`item-${key}`] || queue.value[`item-${key}`] <= 1) {
    queue.value = dissoc(`item-${key}`, queue.value);
  } else {
    queue.value[`item-${key}`] = queue.value[`item-${key}`] - 1;
  }
};

export const isActive = queue => computed(() => queue.value && Object.keys(queue.value).length > 0);
